import React, { useState } from "react";
import { ICategoryButtons } from "../interface/interfaces";
import { FlexCenter } from "../components/layout/FlexCenter/FlexCenter";
import IconComponent from "../components/shared/IconComponents/IconComponent";
import { TextCustom } from "../components/ui/TextCustom";


export const useTabButtons = (tabBtn:  ICategoryButtons[], iconSize = 1.4 ) => {
    const [activeBtn, setActiveBtn] = useState(tabBtn[0].iconName);

    const onBtnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.preventDefault();
        setActiveBtn(e.currentTarget.value);
    };

    const createdButtons = tabBtn.map((btn: ICategoryButtons, idx: number) => {
        return (
            <button onClick={(e) => onBtnClick(e)} key={idx} className={`btn-tab__item btn-tab__item--${btn.iconName === activeBtn ? 'selected' : ''}`} value={btn.iconName}>
                <FlexCenter direction="v" position="center" gap={0.5}>
                    <IconComponent size={iconSize} iconName={`${btn.iconName}${btn.iconName === activeBtn ? '_dark' : ''}`} />
                    <TextCustom weight={btn.iconName === activeBtn ? 500 : 500} size={1.2} color={`${btn.iconName === activeBtn ? 'dark' : 'grey-dark'}`}>
                        {btn.label}
                    </TextCustom>
                </FlexCenter>
            </button>
        );
    });

    const tabButtons = <div className="btn-tab">{createdButtons}</div>;

    return {
        tabButtons,
        activeBtn
    };
}